import { ReactSelectOptions } from "../ReactSelectOptions";

export const typePlans: any[] = [
  { value: "artigos", label: "Somente Artigos" },
  { value: "artigos_ia", label: "Artigos + IA" },
];

export const pricePlans: any[] = [
  { value: "monthly", label: "Mensal" },
  { value: "annual", label: "Anual" },
];
